import React, { useEffect, useState } from 'react';
import api from '../lib/auth';
import FormRenderer from '../components/forms/FormRenderer';

const card = "rounded-2xl border border-[#27272a] bg-[#18181b] shadow-xl";
const btn = "rounded-lg px-3 py-2 text-sm font-semibold transition";

export default function MyFormsPage() {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [message, setMessage] = useState('');

  const loadForms = async () => {
    try {
      const res = await api.get('/forms/templates?mine=true');
      const all = Array.isArray(res.data) ? res.data : [];

      // MVP: show all active forms until backend current-user assignment filter is added.
      setTemplates(all.filter(t => (t.status || 'active') === 'active'));
    } catch (e) {
      console.error(e);
      setMessage('Could not load assigned forms.');
    }
  };

  useEffect(() => {
    loadForms();
  }, []);

  const submit = async (responses) => {
    if (!selected) return;
    try {
      await api.post('/forms/submissions', {
        template_id: selected.id || selected._id,
        responses,
        status: 'submitted',
      });
      setMessage('Report submitted.');
      setSelected(null);
    } catch (e) {
      console.error(e);
      setMessage(e?.response?.data?.detail || 'Submission failed.');
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] text-white p-4 md:p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">My Forms</h1>
        <p className="text-sm text-zinc-400">Open and submit assigned operational reports.</p>
      </div>

      {message ? (
        <div className="mb-4 rounded-xl border border-blue-500/30 bg-blue-500/10 px-4 py-3 text-sm text-blue-200">
          {message}
        </div>
      ) : null}

      {!selected ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {templates.map(t => (
            <div key={t.id || t._id} className={`${card} p-5`}>
              <h2 className="text-lg font-bold">{t.name}</h2>
              <p className="text-sm text-zinc-500 mb-4">{t.category || 'Operations'}</p>
              <button onClick={() => setSelected(t)} className={`${btn} bg-blue-600 hover:bg-blue-500`}>
                Open Form
              </button>
            </div>
          ))}

          {!templates.length ? (
            <div className="rounded-2xl border border-dashed border-[#3f3f46] p-10 text-center text-zinc-500">
              No assigned forms found.
            </div>
          ) : null}
        </div>
      ) : (
        <div className={`${card} p-5 max-w-3xl`}>
          <button onClick={() => setSelected(null)} className="mb-4 text-sm text-blue-400 hover:text-blue-300">
            ← Back to my forms
          </button>
          <h2 className="text-xl font-bold">{selected.name}</h2>
          <p className="text-sm text-zinc-500 mb-5">{selected.description}</p>
          <FormRenderer template={selected} onSubmit={submit} />
        </div>
      )}
    </div>
  );
}
